module.exports = __webpack_public_path__ + "img/38675-004.aaad4e98.jpg";